"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListView_1 = require("../ListView");
var ColumnLayout = /** @class */ (function () {
    /**
     * @param columnCount Number of columns to display
     * @param innerSpacing Spacing between items
     * @param outerSpacing Spacing of layout with outer box
     * @param minHeight min height of the layout, the ratio will be keep to this hight if given
     */
    function ColumnLayout(columnCount, innerSpacing, outerSpacing, minHeight) {
        if (columnCount === void 0) { columnCount = 1; }
        if (innerSpacing === void 0) { innerSpacing = 0; }
        if (outerSpacing === void 0) { outerSpacing = { top: 0, left: 0, right: 0 }; }
        if (minHeight === void 0) { minHeight = 0; }
        this.columnCount = columnCount;
        this.innerSpacing = innerSpacing;
        this.outerSpacing = outerSpacing;
        this.minHeight = minHeight;
        this.orientation = ListView_1.Orientation.Vertical;
    }
    ColumnLayout.prototype.layout = function (items, viewportSize) {
        var _this = this;
        var boundaries = this.outerSpacing.left + this.outerSpacing.right + ((this.columnCount - 1) * this.innerSpacing);
        var columnWidth = (viewportSize.width - boundaries) / this.columnCount;
        var ys = new Array(this.columnCount).fill(this.outerSpacing.top);
        var xs = new Array(this.columnCount).fill(0).map(function (_, i) { return (columnWidth + _this.innerSpacing) * i + _this.outerSpacing.left; });
        var column = 0;
        return items.map(function (size) {
            var scale = columnWidth / size.width;
            var scaledHeight = size.height * scale;
            var height = scaledHeight < _this.minHeight ? _this.minHeight : scaledHeight;
            var nextColumn = (column + 1) % _this.columnCount;
            if (ys[column] > ys[nextColumn]) {
                column = nextColumn;
            }
            var rect = { x: xs[column], y: ys[column], width: columnWidth, height: height };
            ys[column] += height + _this.innerSpacing;
            column = (column + 1) % _this.columnCount;
            return rect;
        });
    };
    return ColumnLayout;
}());
exports.ColumnLayout = ColumnLayout;
